import {
    convertEventDateListToUserTimezone,
    filterByEventName,
    mapRevisedByPreviousIsPreliminary
} from "./mappers";
import { urlFactory } from "../helpers";

const eventDatesRequested = (store) => {
    store.setState({
        isFetching: true,
        eventDatesFetchError: false,
        eventDates: null,
        eventDetails: {},
    });
};

const eventDatesReceived = (store, eventDates) => {
    const {
        settings: {
            timezoneOffset,
            filter: { eventName },
        },
    } = store.getState();
    const filteredEventDates = filterByEventName(eventDates, eventName);
    const mappedEventDates = convertEventDateListToUserTimezone(
        filteredEventDates,
        timezoneOffset
    );
    const mappedReviseEventDates =
        mapRevisedByPreviousIsPreliminary(mappedEventDates);

    store.setState({
        isFetching: false,
        eventDatesFetchError: false,
        eventDates: mappedReviseEventDates,
    });
};

const eventDatesError = (store) => {
    store.setState({
        eventDates: null,
        isFetching: false,
        eventDatesFetchError: true,
    });
};

export const fetchEventDates = (store) => {
    eventDatesRequested(store);

    const { config, settings } = store.getState();

    const url = urlFactory.getEventDates(config, settings);
    fetch(url, {
        method: "GET",
        headers: { Accept: "application/json" },
    })
        .then((response) => {
            if (response.ok) {
                response
                    .json()
                    .then((eventDates) =>
                        eventDatesReceived(store, eventDates)
                    );
            } else if (response.status === 404) {
                eventDatesReceived(store, []);
            } else {
                eventDatesError(store);
            }
        })
        .catch((err) => {
            console.error(err);
            eventDatesError(store);
        });
};
